import OfferToast from './OfferToast';
import { OfferToastDashboard, OfferToastSales } from './variants';

OfferToast.Dashboard = OfferToastDashboard;
OfferToast.Sales = OfferToastSales;

export { OfferToast };
